const features = [
  {
    icon: 'ri-search-eye-line',
    title: 'Product Discovery',
    description: 'Find trending products faster with our organized spreadsheet system. Browse thousands of curated items across multiple categories with just a few clicks.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Category Organization',
    description: 'Explore fashion, sneakers, accessories and more through our carefully structured category system designed for intuitive navigation.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Research Efficiency',
    description: 'Compare options before purchasing with side-by-side product analysis. Our spreadsheet format makes product research dramatically faster.',
  },
  {
    icon: 'ri-user-smile-line',
    title: 'Beginner Support',
    description: 'Simple step-by-step guides for new users. No prior spreadsheet experience needed — start discovering great products right away.',
  },
];

const FeaturesSection = () => {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="px-6 md:px-10 lg:px-20 max-w-[1400px] mx-auto">
        <div className="mb-12">
          <p className="text-sm font-medium text-foreground-400 uppercase tracking-wider mb-3">Why Thousands Choose This</p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            Save Time & Shop Smarter
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-100 rounded-xl p-6 md:p-8 hover:bg-accent-50/60 transition-colors group cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100/60 text-accent-700 mb-5 group-hover:bg-accent-200/60 transition-colors">
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">{feat.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{feat.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;